import BulkAddToCartDialog from "~/features/bulkAddToCart/components/BulkAddToCartDialog";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import type { CMSChipLinkProps } from "~/features/cms/components/cmsChip/CMSChipLink";
import styled from "@emotion/styled";
import { Chip } from "@schaeffler-commerce/design-system";
import { Avatar } from "@schaeffler-commerce/design-system";

const CMSChipLinkPopup = ({ chip, iconUrl, className, variant = "assist" }: CMSChipLinkProps) => {
  const { val: isOpen, setTrue: handleOpen, setFalse: handleClose } = useBooleanState(false);

  return (
    <>
      <StyledChip
        className={className}
        component="button"
        onClick={handleOpen}
        variant={variant}
        label={chip.title || chip.navigationEntry.linkComponent.name}
        {...(iconUrl && {
          avatar: <Avatar src={iconUrl} sx={{ borderRadius: 0 }} />,
        })}
      />
      {isOpen && <BulkAddToCartDialog onClose={handleClose} />}
    </>
  );
};

const StyledChip = styled(Chip)({
  cursor: "pointer",
});

export default CMSChipLinkPopup;
